import React from 'react';
import Link from 'next/link';
import type { ParsedUrlQuery } from 'querystring';

interface PaginationLinkProps {
	children: JSX.Element;
	pathName: string;
	query: ParsedUrlQuery;
}

const PaginationLink: React.FC<PaginationLinkProps> = ({ children, pathName, query = {} }) => (
	<Link legacyBehavior shallow href={{ pathname: pathName, query }} scroll={false}>
		{children}
	</Link>
);

export default PaginationLink;
